<template>
    <div class="outer-box">
        <div class="m-portlet left  m-b-0">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">
                            筛选条件
                        </h3>
                    </div>
                </div>
            </div>
            <div class="m-portlet__body m-portlet__body--small-padding ">
                <el-form label-position="top">
                    <el-form-item label="校区选择">
                        <el-select v-model="filter.section_ids"
                                   clearable
                                   placeholder="请选择校区"
                                   multiple
                                   @change="handleScreen()">
                            <el-option
                                    v-for="item in sections"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="学期选择">
                        <el-select v-model="filter.semester_type_ids"
                                   clearable
                                   placeholder="请选择学期"
                                   multiple
                                   @change="handleScreen()">
                            <el-option
                                    v-for="item in semesterTypes"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="老师选择">
                        <el-select v-model="filter.teacher_id" clearable placeholder="请选择老师名字" filterable remote
                                   :remote-method="handleSearchTeacher" @change="handleScreen()">
                            <el-option
                                    v-for="item in haveTeachers"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="学科选择">
                        <el-select v-model="filter.subject_id" clearable placeholder="请选择学科" @change="handleScreen()">
                            <el-option
                                    v-for="item in subjects"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="类型选择">
                        <el-select v-model="filter.introducation" clearable placeholder="请选择类型" @change="handleScreen()">
                            <el-option
                                    v-for="item in introducations"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态选择">
                        <el-select v-model="filter.status" clearable placeholder="请选择类型" @change="handleScreen()">
                            <el-option
                                    v-for="item in status_type"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button v-if="powers.includes(72)" @click="handleCreateTeacher()">创建老师</el-button>
                    </el-form-item>
                </el-form>

            </div>
        </div>
        <div class="m-portlet right m-b-0">
            <div class="m-portlet__body" :style="{'height':clientHeight-96-61.59-10+'px'}" v-loading="loading">
                <el-table v-if="!loading"
                          :data="orderTeachers"
                          style="width: 100%"
                          :height="clientHeight-96-61.59-2.2-2-13-20"
                          size="middle">
                    <el-table-column prop="id" label="工号" min-width="15%"></el-table-column>
                    <el-table-column prop="name" label="姓名" min-width="15%"></el-table-column>
                    <el-table-column prop="subject_name" label="学科" min-width="15%"></el-table-column>
                    <el-table-column prop="introducation" label="类型" min-width="15%"></el-table-column>
                    <el-table-column prop="work" label="状态" min-width="10%"></el-table-column>
                    <el-table-column prop="user_account" label="是否有账号" min-width="10%"></el-table-column>
                    <el-table-column label="操作" min-width="20%">
                        <template slot-scope="scope">
                            <el-button  @click="handleUpdateTeacher(scope.row.id)">修改</el-button>
                        <!--<el-button  @click="handleDeleteTeacher(scope.row.id)">删除</el-button>-->
                        </template>
                    </el-table-column>
                    <!--<el-table-column prop="start_date" label="开始日期"></el-table-column>-->
                    <!--<el-table-column prop="end_date" label="结束日期"></el-table-column>-->
                </el-table>
            </div>

            <div class="m-portlet__foot">
                <!--分页-->
                <div class="text-center">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "teachers-list",
        data() {
            return {
                path: "/teacher/list",
                loading: true,
                button_loading:false,
                teachers: [],
                semesters: [],
                subjects: [],
                semesterTypes: [],
                sections: [],
                haveTeachers: [],
                introducations:[
                    {
                    id:'全职',
                    name:'全职'
                },{
                    id:'兼职',
                    name:'兼职'
                }
                ],
                status_type:[
                    {
                        id:'active',
                        name:'在职'
                    },{
                        id:'cancel',
                        name:'离职'
                    }
                ],
                filter: {
                    semester_id: this.$store.state.config.nowSemester.id,
                    teacher_id: "",
                    subject_id: "",
                    status:'',
                    introducation:'',
                    section_ids:[],
                    semester_type_ids:[]
                },
                teacherName: '',
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
                id: [],
                dialog_CreateTeacher: {
                    teacher: {
                        name: '',
                        gender_id: 1,
                        birthday: '2000-01-01',
                        phone: '',
                        subject_id: '',
                        semester_id: [],
                        introducation:''
                    },
                    loading: true,
                    button_loading: false,
                },
                dialog_UpdateTeacher: {
                    semesters:[{
                        semesterType_name:'',
                        section_data:[{
                            section_name:'',
                            disabled:false,
                            id:'',
                            name:''
                        }]
                    }],
                    teacher:{
                        id:'',
                        name:'',
                        email:'',
                        phone:'',
                        subject_id:'',
                        introducation:'',
                        status:'',
                        remark:'',

                    },
                    teacher_semesters:[],
                    subjects:[],
                    button_loading:false,

                }
            }
        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            orderTeachers: function () {
                return this._.values(this.teachers);
            }
        },
        created() {
            this.handleCreate();
            this.handleShow();
        },
        methods: {
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData);

                this.$wApi.send(this.path, 'init', {});
                this.loading = true;
            },
            handleShow() {
                this.$wApi.send(this.path, 'list', {
                    'pageSize': this.currentPageSize,
                    'page': this.currentPage,
                    'filter': this.filter
                });
            },

            handleData(event, data) {
                switch (event) {
                    case 'list':
                        this.teachers = data.teachers;
                        this.total = data.total;
                        this.loading = false;
                        break;
                    case 'init':
                        this.semesters = data.semesters;
                        this.subjects = data.subjects;
                        this.haveTeachers = data.teachers;
                        this.semesterTypes=data.semesterTypes;
                        this.sections=data.sections;
                        break;
                    case 'search':
                        this.haveTeachers = data.employees;
                        break;
                    case 'store_teacher':
                        this.dialog_CreateTeacher.button_loading = false;
                        this.total = this.total+1;
                        this.$Win.closeModal();
                        this.$message.success('创建老师成功');
                        break;
                    case 'store_teacher_error':
                        this.dialog_CreateTeacher.button_loading = false;
                        break;
                    case 'get_teacher_detail':
                        this.dialog_UpdateTeacher.semesters = data.semesters;
                        this.dialog_UpdateTeacher.teacher = data.teacher;
                        this.dialog_UpdateTeacher.teacher_semesters = data.teacher_semesters;
                        this.dialog_UpdateTeacher.subjects = data.subjects;
                        break;
                    case 'update_teacher':
                        this.$message.success('修改成功');
                        this.$set(this.teachers,data.teacher_info.id,data.teacher_info)
                        this.dialog_UpdateTeacher.button_loading=false
                        break;
                    case 'update_teacher_error':
                        this.dialog_UpdateTeacher.button_loading=false
                        break;
                    case 'set_sms_to_register':
                        this.button_loading=false;
                        this.$message.success('发送成功');
                        break;
                    case 'set_sms_to_register_error':
                        this.button_loading=false;
                        break;
                }
            },
            //筛选老师
            handleSearchTeacher(query) {
                this.$wApi.send(this.path, 'search', {
                    'teacherKeyName': query
                });
            },
            handleScreen() {
                this.$wApi.send(this.path, 'list', {
                    'pageSize': 10,
                    'page': 1,
                    'filter': this.filter
                });
            },
            //创建老师
            handleCreateTeacher() {
                this.$Win.openModal('Dialog_CreateTeacher', 350, 400, '创建老师');
            },

            handleSizeChange(val) {
                this.currentPageSize = val;
                this.handleShow();
                this.loading = true;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.handleShow();
                this.loading = true;
            },
            handleUpdateTeacher(teacher_id){
                this.$Win.openModal('Dialog_UpdateTeacher', 650, 700, '老师详情', {'teacher_id':teacher_id});
            },
            handleDeleteTeacher(){

            },
            handleSendRegister(teacher_id){
                this.button_loading=true;
                this.$wApi.send(this.path, 'set_sms_to_register', {
                    'teacher_id': teacher_id
                });
            }
        },
        destroyed() {

        }
    }
</script>

<style scoped lang="scss">
    .left {
        float: left;
        width: 220px;
    }

    .right {
        margin-left: 225px;
    }
</style>

